import { render, staticRenderFns } from "./StockListComponent.vue?vue&type=template&id=560a0d5c&scoped=true"
import script from "./StockListComponent.vue?vue&type=script&lang=js"
export * from "./StockListComponent.vue?vue&type=script&lang=js"
import style0 from "./StockListComponent.vue?vue&type=style&index=0&id=560a0d5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a0d5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560a0d5c')) {
      api.createRecord('560a0d5c', component.options)
    } else {
      api.reload('560a0d5c', component.options)
    }
    module.hot.accept("./StockListComponent.vue?vue&type=template&id=560a0d5c&scoped=true", function () {
      api.rerender('560a0d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/StockListComponent.vue"
export default component.exports